import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import OrderTableHead from 'pages/ip-program/table/Head';
import Body from 'pages/ip-program/table/Body';
import { TableWrapper } from 'styles/pages/orders';

const ArtFilesTable = ({ artFiles = [], onDelete, onApprove, onReject }) => (
  <TableWrapper>
    <TableContainer className='container' component={Paper}>
      <Table>
        <OrderTableHead />
        <TableBody>
          <Body
            artFiles={artFiles}
            onDelete={onDelete}
            onApprove={onApprove}
            onReject={onReject}
          />
        </TableBody>
      </Table>
    </TableContainer>
  </TableWrapper>
);

export default ArtFilesTable;
